<template>
    <div>
        <!-- 白名单管理弹窗 -->
		<el-dialog title="白名单管理" @close="closeWhiteVisible" :visible.sync="visible" :close-on-click-modal="false" width="52%">
			<div class="whiteListContent">
				<p class="f-s-12 m-b-5 c-999">说明：质控白名单将用于：质控领取任务后系统自动将白名单译员加入项目备用资源池；（仅在质控领取订单时触发）</p>
				<p class="f-s-12 t-i-2 c-999 m-b-15">备用资源将不受项目领取数量限制</p>
				<div class="d-f justify-s align-c m-b-15">
					<el-input class="w-240 m-r-10" placeholder="请输入译员昵称进行搜索" v-model="searchWhiteKey"></el-input>
					<el-button type="primary" plain icon="el-icon-search" @click="getWhiteList">搜索</el-button>
					<el-button type="info" plain icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
				</div>
				<div class="d-f justify-b f-s-12 c-333 m-b-10">
					<span>信任译员列表</span>
					<span>白名单人数：共<em class="c-409EFF f-w-600">{{page1.maxLimit}}</em>人</span>
				</div>
				<el-table :data="whiteList" border :size="small" max-height="300px">
					<el-table-column prop="trName" label="译员昵称" align="center">
						<template slot-scope="scope">
							<span style="white-space: pre;">{{ scope.row.trName }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="statusDesc" label="语种方向" align="center">
                        <template slot-scope="scope">
                            {{ $sysLan.get(scope.row.slan) }}--{{ $sysLan.get(scope.row.tlan) }}
                        </template>
                    </el-table-column>
					<el-table-column prop="trustTime" label="信任日期" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.trustTime&&scope.row.status==1">{{ scope.row.trustTime | parseTime }}</span>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
					<el-table-column prop="" label="操作" align="center" width="120px">
						<template slot-scope="scope">
							<el-button v-if="scope.row.status!=1" type="text" size="mini" class="c-danger" @click="shield(scope.row, 1)">信任</el-button>
							<el-button v-if="scope.row.status == 1" type="text" size="mini" @click="shield(scope.row, 2)">取消</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="t-c" v-if="page1.total > 10">
					<el-pagination
						class="p-t-10"
						@current-change="handleCurrentChange"
						:current-page="page1.pageNum"
						:page-size="page1.pageSize"
						layout="total, prev, pager, next, jumper"
						:total="page1.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import { dotWhiteListPage, setDotWhiteList } from '@/api/qc/qcflow'
import {statistics} from '@/api/dot/flow'

export default {
    props: ['whiteListVisible', 'staParams'],
    data() {
        return {
            visible: false, //白名单管理弹窗显示状态
			whiteList: [],//白名单列表
			searchWhiteKey: '',//白名单搜索关键字
			page1: {//白名单列表分页
				pageSize: 10,
				pageNum: 1,
				total: 0,
				maxLimit: 0,
			},
			tranlaterName: '', //拉黑译员昵称
        }
    },
    computed: {
		...mapGetters(['permissions']),
		...mapState({
		    userInfo: state => state.user.userInfo
		}),
	},
    methods: {
        init() {
            this.visible = this.whiteListVisible;
            this.getWhiteList();
        },

		// 关闭白名单管理弹窗
		closeWhiteVisible() {
			this.searchWhiteKey = '';
			this.visible  = false;
		},

		// 获取白名单列表
		getWhiteList() {
			dotWhiteListPage({
				current: this.page1.pageNum,
				size: this.page1.pageSize,
				staffId: this.userInfo.staffId,
				trName: this.searchWhiteKey,
			}).then(res=>{
				this.whiteList = res.data.data.records;
				this.page1.total = res.data.data.total;
				this.page1.maxLimit = res.data.data.maxLimit;
			}).catch((error)=>{
				this.whiteList = [];
			})
			statistics(Object.assign({
				event_name: '白名单管理',
				event_type: 'click',
				class_name: 'qcDisableTrPage',
				class_url: '/dotadmin/dotadmin/qcflow/qcDisableTrPage',
				event_params: '{current: this.page1.pageNum, size: this.page1.pageSize, staffId: this.userInfo.staffId, trName: this.searchWhiteKey}'
			}, this.staParams))
		},

		// 白名单分页
		handleCurrentChange(val) {
            this.page1.pageNum = val;
            this.getWhiteList();
        },

		// 重置
		resetSearch() {
			this.searchWhiteKey = '';
			this.getWhiteList();
		},

		// 信任/取消拉黑
		shield(row, status) {
			this.$confirm(`确定${status==1?'信任':'取消信任'}译员“${row.trName}”？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				setDotWhiteList({
					staffId: this.userInfo.staffId,
					status: status,
					trId: row.trId,
                    slan: row.slan,
                    tlan: row.tlan,
				}).then(res=>{
					this.$message.success('操作成功');
					this.getWhiteList();
				})
			})
		},
    },
}
</script>